import React, { useState, useEffect } from "react"
import Img from "gatsby-image/withIEPolyfill"
import styled from "@emotion/styled"
import Credit from "../components/credit"
import YoutubeModal from "../components/YoutubeModal"
import { device } from "../device"

const Slider = ({ items, type = "image" }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [toggleIndex, setToggleIndex] = useState(false)
  const [toggleMovie, setToggleMovie] = useState(false)
  const [currentMovieId, setCurrentMovieId] = useState(null)

  const currentSliderItem = items[activeIndex]
  const itemsCount = items.length

  const prevClick = () => {
    activeIndex === 0
      ? setActiveIndex(itemsCount - 1)
      : setActiveIndex(activeIndex - 1)
  }

  const nextClick = () => {
    activeIndex === itemsCount - 1
      ? setActiveIndex(0)
      : setActiveIndex(activeIndex + 1)
  }

  const toggleMovieView = () => {
    setCurrentMovieId(items[activeIndex].node.srcId)
    setToggleMovie(!toggleMovie)
  }

  const toggleIndexHandler = () => {
    setToggleIndex(!toggleIndex)
  }

  return (
    <>
      {type === "image" ? (
        <SliderContainer onClick={nextClick}>
          <Img
            fluid={currentSliderItem.node.image.fluid}
            objectFit="contain"
            objectPosition="center right"
          />
        </SliderContainer>
      ) : (
        <>
          <MovieContainer onClick={nextClick}>
            <Img
              fluid={currentSliderItem.node.image.fluid}
              objectFit="contain"
              objectPosition="center right"
            />
            <PlayButton onClick={toggleMovieView}>Play movie</PlayButton>
          </MovieContainer>
          {toggleMovie && (
            <YoutubeModal
              srcId={currentMovieId}
              handleClose={toggleMovieView}
            />
          )}
        </>
      )}
      {toggleIndex && (
        <Cover>
          {items.map((edge, index) => {
            return (
              <IndexImgContainer
                onClick={() => {
                  setActiveIndex(index)
                  setToggleIndex(!toggleIndex)
                }}
              >
                <Img fluid={edge.node.image.fluid} objectFit="contain" />
              </IndexImgContainer>
            )
          })}
        </Cover>
      )}
      <CreditWrapper>
        <Credit
          title={currentSliderItem.node.title}
          width={currentSliderItem.node.width || ""}
          height={currentSliderItem.node.height || ""}
          material={currentSliderItem.node.material || ""}
          type={type}
        />
      </CreditWrapper>
      {!toggleIndex && (
        <SliderNavigation>
          <span onClick={prevClick}>prev</span>
          <div>
            {activeIndex + 1} / {itemsCount}
          </div>
          <span onClick={nextClick}>next</span>
        </SliderNavigation>
      )}
      <IndexToggleButton>
        <button onClick={toggleIndexHandler}>
          {toggleIndex ? `Close` : `Show Index`}
        </button>
      </IndexToggleButton>
    </>
  )
}

const PlayButton = styled.button`
  display: inline-block;
  background-color: black;
  color: white;
  font-family: ${props => props.theme.fontFamily.roboto};
  font-size: 0.8rem;
  padding: 4px 8px;
  appearance: none;
  border-radius: 0;
  border: 0;
  cursor: pointer;
`

const MovieContainer = styled.div`
  position: relative;
  max-width: 85%;
  margin-left: auto;
  img {
    max-height: calc(100vh - 80px);
    cursor: url("/right-arrow.svg"), pointer;
  }

  @media ${device.mobile} {
    max-width: 100%;
  }
`

const SliderContainer = styled.div`
  position: relative;
  max-width: 70%;
  margin-left: auto;
  img {
    max-height: calc(100vh - 80px);
    cursor: url("/right-arrow.svg"), pointer;
  }

  @media ${device.mobile} {
    max-width: 100%;
  }
`

const IndexImgContainer = styled.div`
  width: 25%;
  padding: 32px;
  cursor: pointer;

  @media ${device.mobile} {
    width: 50%;
    padding: 16px;
  }
`

const Cover = styled.div`
  background-color: white;
  position: absolute;
  padding: 40px;
  top: 0;
  right: 0;
  width: 70vw;
  min-height: calc(100vh);
  z-index: 9999;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;

  @media ${device.mobile} {
    padding: 0 16px;
    top: 64px;
    left: 0;
    width: 100vw;
    min-height: calc(100vh - 80px);
  }
`

const CreditWrapper = styled.div`
  position: absolute;
  bottom: calc(40px - 1rem);
  left: 20%;
  display: block;

  @media ${device.mobile} {
    position: relative;
    left: 0;
    bottom: 0;
    display: block;
  }
`

const SliderNavigation = styled.div`
  font-family: ${props => props.theme.fontFamily.roboto};
  position: absolute;
  left: 20%;
  bottom: 7%;
  display: block;
  z-index: 9999;
  > span {
    display: none;
  }

  @media ${device.mobile} {
    position: relative;
    left: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    span {
      display: block;
      font-family: ${props => props.theme.fontFamily.roboto};
      font-size: 0.8rem;
      cursor: pointer;
    }
  }
`

const IndexToggleButton = styled.div`
  position: absolute;
  left: 20%;
  bottom: 10%;
  display: block;
  z-index: 2000;

  @media ${device.mobile} {
    background-color: white;
    display: flex;
    border-top: 1px solid hsla(90, 80%, 40%, 0.15);
    width: 100%;
    position: fixed;
    z-index: 9999;
    left: 0;
    bottom: 0;
    height: 48px;
    justify-content: center;
    align-items: center;
  }

  button {
    display: block;
    font-size: 14px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }
`

export default Slider
